import { defineMessage } from 'services/localization';

export const messages = {
    titleText: defineMessage('please_note_that_the_su_ion_of_the_subscription'),
    organisationsSection: defineMessage('organisations'),
    goToAccountButton: defineMessage('go_to_my_account'),
    contactOwnerButton: defineMessage('contact_account_owner'),
};
